import PalletsList from "./PalletsList";

export default {
    list: PalletsList,
};
